'use strict';

goog.provide("Ntry.StudyIntro");

Ntry.StudyIntro = function() {
    this._view = Ntry.interfaceManager.getDom('ntryIntroArea');
    this._popupHelper = new Entry.popupHelper(true);
    this.createDom();
    Ntry.addEventListener('changeMode', this, this.setMode);
    this.textModeShown = false;
    this.blockModeShown = false;
};

(function(p){

    p.createDom = function () {
        var parent = this._view;
        var container = Ntry.createElement('div', parent, null, 'ntryIntroContainer');
        var title = Ntry.createElement('div', container, null, 'ntryIntroTitle')
        this._closeButton = Ntry.createElement('span', title, null, 'ntryIntroCloseButton');
        this._closeButton.innerHTML = Lang.Menus.close;

        var content = Ntry.createElement('div', container, null, 'ntryIntroContent');
        this._leftImg = Ntry.createElement('div', content, null, 'ntryIntroLeftImg');

        var rightDiv = Ntry.createElement('div', content, null, 'ntryIntroRightDiv');
        this._rightTop = Ntry.createElement('div', rightDiv, null, 'ntryIntroRightTop');
        this._rightCenter = Ntry.createElement('div', rightDiv, null, 'ntryIntroRightCenter');

        this._startButton = Ntry.createElement('span', content, null, 'ntryIntroStartButton');
        this._startButton.innerHTML = Lang.Menus.start;

        var self = this;
        this._view.bindOnClick(function(e) {
            if (e.target == this) {
                self.hide();

                var stageId = Ntry.configManager.getConfig("stageId");
                if (stageId == 1 || stageId == 8 || stageId == 13) {
                    self.showHelpPopup(stageId);
                }
            }
        });
    };

    p.update = function() {};

    p.loadConfig = function () {
        this._intro = Ntry.configManager.getConfig('intro');
        if (this._intro)
            this.fillContent();
    };

    p.fillContent = function() {
        var intro = this._intro;
        var stageId = Ntry.configManager.getConfig("stageId");

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryIntroLeftImg');


        if (stageId <= 12) {
            this._leftImg.addClass('cpartyIntroLeft1Img');
            if (stageId/12 && stageId%12==0)
                this._rightTop.innerHTML = 12 + '/12';
            else
                this._rightTop.innerHTML = stageId%12 + '/12';
        } else if (stageId <= 22) {
            this._leftImg.addClass('cpartyIntroLeft2Img');
            if (stageId/22 && stageId%22==0)
                this._rightTop.innerHTML = 10 + '/10';
            else
                this._rightTop.innerHTML = stageId%12 + '/10';
        }

        this._rightCenter.innerHTML = intro.content;

        var self = this;
        this._closeButton.bindOnClick(function() {
            if (stageId == 1 || stageId == 8 || stageId == 13) {
                self.showHelpPopup(stageId);
            }
            self.hide();
        });

        this._startButton.bindOnClick(function() {
            if (window.cpartyuserkey)
                Ntry.dispatchEvent('saveLogs', 'start');
            self.hide();
            if (stageId == 1 || stageId == 8 || stageId == 13) {
                self.showHelpPopup(stageId);
            }
        });

        $(this._view).css('display', 'block');
    };

    p.setHelpPopup = function(stageId) {
        var mode = 2;
        this._popupHelper.addPopup('mazeHelp', {
            title: Lang.Menus.mission_guide,
            setPopupLayout: function(popup) {
                var content = Entry.Dom('div', {
                    class: 'helpImage helpImage_' + mode + '_' + stageId,
                });
                popup.append(content);
            }
        });
    }

    p.showHelpPopup = function(stageId) {
        if (this.mode === Entry.Workspace.MODE_VIMBOARD)
            return;
        this.setHelpPopup(stageId);
        this._popupHelper.show('mazeHelp');
    }

    p.setMode = function(mode) {
        mode = mode === undefined ? 0 : mode;
        mode = isNaN(mode) ? mode.boardType : mode;
        this.mode = Number(mode);
        if(Entry.Workspace.MODE_BOARD === this.mode && !this.blockModeShown) {
            this._rightCenter.innerHTML = this._intro.content;
            $(this._view).css('display', 'block');
            this.blockModeShown = true;
        } else if(Entry.Workspace.MODE_VIMBOARD === this.mode && !this.textModeShown){
            this._rightCenter.innerHTML = this._intro.textContent || '';
            $(this._view).css('display', 'block');
            this.textModeShown = true;
        }
    }

    p.hide = function() {
        $(this._view).css('display', 'none');
        Ntry.dispatchEvent("hideIntro", this.mode);
    }

})(Ntry.StudyIntro.prototype);
